import type { Components } from "@mui/material";
import type { themeBBJ } from "../material.theme";

declare module "@mui/material/Checkbox" {
  interface CheckboxPropsSizeOverrides {
    xs: true;
  }
}

export const MuiCheckbox: Components<typeof themeBBJ>["MuiCheckbox"] = {
  styleOverrides: {
    root: {
      variants: [
        {
          props: { size: "xs" },
          style: ({ theme }) => ({ padding: 0, marginLeft: theme.spacing(1), marginRight: theme.spacing(1) }),
        },
      ],
    },
  },
};
